// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Constants imports
import { URLConstants } from '../../_constants/url-constants';

// Model imports
import { OwnerLogReturnedMailEditorResultDto } from '../_models/log-returned-mail/owner-log-returned-mail-editor-result-dto';
import { OwnerLogReturnedMailParametersDto } from '../_models/log-returned-mail/owner-log-returned-mail-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class LogReturnedMailService {
    constructor(private readonly httpClient: HttpClient) {}

    getLogReturnedMailEditor(
        communityId: number,
        customerId?: string
    ): Observable<OwnerLogReturnedMailEditorResultDto> {
        let url = `${URLConstants.ccOwnerApiBaseUrl}communication/logreturnedmail/editor?clearCache=true&communityId=${communityId}`;
        if (!!customerId) {
            url = `${url}&customerId=${customerId}`;
        }

        return this.httpClient
            .get(url)
            .pipe(map((response: any) => plainToClass(OwnerLogReturnedMailEditorResultDto, response)));
    }

    saveLogReturnedMail(params: OwnerLogReturnedMailParametersDto): Observable<any> {
        const url = `${URLConstants.ccOwnerApiBaseUrl}communication/logreturnedmail`;
        return this.httpClient.post(url, classToPlain(params));
    }
}
